import { ICampaignAppTech } from 'api/types/_campaign';
import { Option } from 'api/types/_public';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import DropdownOption from 'components/Common/DropdownOption';
import DropdownStatus from 'components/Common/DropdownStatus';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { APP_TECH_TYPE, CAMPAIGN_TYPE, COLORS_STATUS_CAMPAIGN, STATUS_CAMPAIGN_OPTIONS } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, CardHeader, Col, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import TableContainer from "../../../components/Common/TableContainer";
import { allAppTech, deleteMultiCampaignAppTech, getAllPartners, getCampaignAppTechs as onGetCampaignAppTechs, postCreateNewsOfCampaign, putStatusCampaignAppTech } from "../../../store/thunks";
import CampaignForm from './CampaignForm';
import { filterMediaOptions } from 'helpers/format';
export interface Tag {
    id: string;
    text: string;
}

const TYPE_SELECT_DEFAULT: string = 'id';

registerLocale('en', en);
registerLocale('ko', ko);

const CampaignList = (activeTab?: any) => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const STATUS_CAMPAIGN_OPTIONS_LANG: any = STATUS_CAMPAIGN_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 30),
        sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
        order_by: withDefault(StringParam, 'DESC'),
        is_active: withDefault(StringParam, ''),
        type: withDefault(StringParam, `${CAMPAIGN_TYPE.APPTECH}`),
        apptech_id: withDefault(StringParam, ''),
        media_id: withDefault(StringParam, ''),

    });

    const [appTechs, setAppTechs] = useState<{ label: string, value: string, name: string, type: number }[]>([]);

    const [partners, setPartners] = useState<{ label: string, value: string, name: string }[]>([]);

    const [statusSearch, setStatusSearch] = useState<Option | null>(STATUS_CAMPAIGN_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.is_active)) || null);

    const [appSearch, setAppSearch] = useState<Option | null>(appTechs?.find((item) => String(item?.value) === String(query?.apptech_id)) || null);

    const [mediaSearch, setMediaSearch] = useState<Option | null>(partners?.find((item) => String(item?.value) === String(query?.media_id)) || null);

    const [dateSearch, setDateSearch] = useState<any[]>([query?.start_date ? moment(query?.start_date, 'Y-MM-DD').toDate() : null, query?.end_date ? moment(query?.end_date || '', 'Y-MM-DD').toDate() : null]);

    const [startDate, endDate] = dateSearch;

    const [campaignDetail, setCampaignDetail] = useState<ICampaignAppTech | null>(null);


    const [idLoading, setIdLoading] = useState<string | number | null>(null);

    const [idAutoPublishLoading, setIdAutoPublishLoading] = useState<string | number | null>(null);

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.Campaign;

    const CampaignProperties = createSelector(
        selectLayoutState,
        (state) => ({
            campaignAppTechs: state.campaignAppTechs,
            isCampaignAppTechSuccess: state.isCampaignAppTechSuccess,
            isCampaignAppTechLoading: state.isCampaignAppTechLoading,
            error: state.error,
        })
    );

    // Inside your component
    const { campaignAppTechs, error, isCampaignAppTechLoading } = useSelector(CampaignProperties);

    useEffect(() => {
        dispatch(onGetCampaignAppTechs(query));
    }, [JSON.stringify(query)]);

    const searchData = () => {
        const queryNew = {
            ...query,
            apptech_id: appSearch?.value || '',
            media_id: mediaSearch?.value || '',
            is_active: `${statusSearch?.value}`,
            page: 1,
            time_request: + new Date()
        };
        setQuery(queryNew);
    };

    const resetData = () => {
        const queryNew = {
            ...query,
            apptech_id: '',
            media_id: '',
            is_active: '',
            order_by: 'DESC',
            sort_by: TYPE_SELECT_DEFAULT,
            time_request: + new Date(),
            page: 1,
        };
        setQuery(queryNew, "push");
        setAppSearch((_prev) => null);
        setMediaSearch((_prev) => null);
        setStatusSearch(null);
        setDateSearch([queryNew?.start_date ? moment(queryNew?.start_date || "", 'Y-MM-DD').toDate() : null, queryNew?.end_date ? moment(queryNew?.end_date || "", 'Y-MM-DD').toDate() : null]);
    };

    const triggerRefresh = async (type: string = '') => {
        onCloseClick();
        setQuery({
            ...query,
            time_request: + new Date(),
        }, "push");
        if (type === 'REFRESH_MEDIA') {
            const [res1]: any = await Promise.all([getAllPartners({})]);
            const _list_partner = (res1?.data || [])?.map((ml: any, index: number) => ({ value: String(ml?.id), label: ml?.name, is_partner: ml?.is_partner, partner_codes: ml?.partner_codes, partner_reporters: ml?.partner_reporters }));
            setPartners((_prev: any) => _list_partner);
        }
    }
    //End::Update

    const handleSetCampaignDetail = (detail: ICampaignAppTech | null) => {
        setCampaignDetail((_prev) => detail);
    }

    const onCloseClick = () => {
        handleSetCampaignDetail(null);
    }

    // Begin::Delete

    const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
    const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
    const [initialValuesDefault, setInitialValuesDefault] = useState<ICampaignAppTech | null>(null);

    const handleConfirmDelete = (item: ICampaignAppTech) => {
        setInitialValuesDefault((_prev) => item);
        setIsConfirm((_prev) => true);
    };

    const handleActionDelete = async () => {
        if (!(initialValuesDefault?.id)) { return; };
        try {
            setIsConfirmLoading((_prev) => true);
            const response: any = await deleteMultiCampaignAppTech({ ids: [initialValuesDefault?.id] });
            if (response?.code === 200) {
                dispatch(onGetCampaignAppTechs(query));
                setIsConfirmLoading((_prev) => false);
                setIsConfirm((_prev) => false);
                setInitialValuesDefault((_prev) => null);
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
            } else {
                setIsConfirmLoading((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsConfirmLoading((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const onCloseConfirmClick = () => {
        setInitialValuesDefault((_prev) => null);
        setIsConfirm((_prev) => false);
    }
    // End::Delete

    const handleUpdateCampaign = async (dataSubmit: { id: string | number, is_active: number } | undefined = undefined) => {
        try {
            if (!dataSubmit) {
                return;
            }
            setIdLoading((_prev) => (dataSubmit?.id) as string);
            const data = {
                is_active: Number(dataSubmit?.is_active),
            };
            const response: any = await putStatusCampaignAppTech((dataSubmit?.id) as string, data);
            if (response?.code === 200) {
                setIdLoading((_prev) => null);
                toast(
                    `${t("The process has been completed.")}`,
                    CONFIG_OPTION_TOAST_NORMAL
                );
                triggerRefresh();
            } else {
                setIdLoading((_prev) => null);
                toast(`${response?.message || response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIdLoading((_prev) => null);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const [idCampaignCreateNewsLoading, setIdCampaignCreateNewsLoading] = useState<null | number>(null);
    const handleCreateNews = async (item: ICampaignAppTech | null) => {
        try {
            if (!item?.id || !!idCampaignCreateNewsLoading) {
                return;
            }
            setIdCampaignCreateNewsLoading((_prev) => item?.id);
            const response: any = await postCreateNewsOfCampaign(item?.id);
            setIdCampaignCreateNewsLoading((_prev) => null);
            if (response?.code === 200) {
                dispatch(onGetCampaignAppTechs(query));
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
            } else {
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIdCampaignCreateNewsLoading((_prev) => null);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };


    // Column
    const columns = useMemo(
        () => [
            {
                Header: t('ID'),
                accessor: "id",
                filterable: true,
                sortable: true,
                thWidth: 60,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => (
                    <>
                        <div style={{ minWidth: '40px' }}>{cell?.value}</div>
                    </>
                ),
            },
            {
                Header: t('Active Action'),
                accessor: "is_active",
                filterable: false,
                sortable: false,
                thClass: 'text-center align-middle',
                thWidth: 100,
                Cell: (cell: any) => {
                    const item: any = cell?.row?.original;
                    const active = item?.is_active;
                    return (
                        <div className="text-center form-check form-switch form-switch-sm position-relative" dir="ltr" style={{ minWidth: '80px' }}>
                            {(String(idLoading) === String(item?.id)) && <span className="position-absolute" style={{ top: '3px', left: 0 }}><Spinner size="sm" className="text-primary" /></span>}
                            <input type="checkbox" className="form-check-input" name="status" id="customSwitchsizelg" checked={Boolean(active)}
                                onChange={(event: any) => {
                                    if (isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_APP_TECH_UPDATE, userPermissions)) {
                                        handleUpdateCampaign(
                                            { id: item?.id, is_active: event.target.checked }
                                        );
                                    }
                                }}
                            />
                        </div>
                    );
                }
            },
            // {
            //     Header: t('Auto Publication'),
            //     accessor: "is_auto_publish",
            //     filterable: false,
            //     sortable: false,
            //     thClass: 'text-center align-middle',
            //     thWidth: 100,
            //     Cell: (cell: any) => {
            //         const item: any = cell?.row?.original;
            //         const auto_publish = item?.is_auto_publish;
            //         return (
            //             <div className="text-center form-check form-switch form-switch-sm position-relative" dir="ltr" style={{ minWidth: '80px' }}>
            //                 {(String(idLoading) === String(item?.id)) && <span className="position-absolute" style={{ top: '3px', left: 0 }}><Spinner size="sm" className="text-primary" /></span>}
            //                 <input type="checkbox" className="form-check-input" name="status" id="customSwitchsizelg" checked={Boolean(auto_publish)}
            //                     onChange={(event: any) => {
            //                         if (isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_CAR_UPDATE, userPermissions)) {
            //                             handleUpdateAutoPublishCampaign(
            //                                 { id: item?.id, is_auto_publish: event.target.checked }
            //                             );
            //                         }
            //                     }}
            //                 />
            //             </div>
            //         );
            //     }
            // },

            // {
            //     Header: t('Name'),
            //     accessor: "name",
            //     filterable: true,
            //     sortable: false,
            //     thWidth: 120,
            //     thClass: 'text-start align-middle',
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (<>
            //             <div style={{ minWidth: '100px' }}>
            //                 {cell?.value || ''}
            //             </div>
            //         </>)
            //     },
            // },
            {
                Header: t('App'),
                accessor: "apptech",
                filterable: true,
                sortable: false,
                thWidth: 160,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '140px' }} className="d-flex flex-wrap ">
                            {item?.apptech?.name || ''}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Media'),
                accessor: "medias",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '130px' }} className="d-flex flex-wrap gap-2">
                            {(item?.medias || [])?.map((_m: any) => (
                                <span key={_m?.id}>
                                    {_m?.media_name || '-'}
                                </span>
                            ))}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Section'),
                accessor: "section",
                filterable: true,
                sortable: false,
                thWidth: 130,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '100px' }} className="d-flex flex-wrap gap-2">
                            {(item?.medias || [])?.map((_m: any) => (
                                <span key={_m?.id}>
                                    {_m?.media_code?.section_title || '-'}
                                </span>
                            ))}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Reporter ID'),
                accessor: "reporters",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '130px' }} className="d-flex flex-wrap gap-2">
                            {(item?.medias || [])?.map((_m: any) => (
                                <span key={_m?.id}>
                                    {_m?.media_reporter_id || '-'}
                                </span>
                            ))}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Byline'),
                accessor: "byline",
                filterable: true,
                sortable: false,
                thWidth: 170,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '160px' }} className="d-flex flex-column gap-2">
                            {(item?.medias || [])?.map((_m: any) => (
                                <div key={_m?.id} className="d-flex">
                                    <span>
                                        {_m?.reporter_by_line || '-'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Schedule'),
                accessor: "campaign_schedules",
                filterable: true,
                sortable: false,
                thWidth: 230,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _times = (item?.campaign_schedules || [])?.map((_s: any) => {
                        const _times = (String(item?.apptech?.type) === String(APP_TECH_TYPE.AUTOMATIC)) ? (_s?.valid_time_ranges || []) : [{ start_time: _s?.time }];
                        return ({
                            interval: _s?.interval || 0,
                            start_time: _times[0] ? (`${String(_times[0]?.start_time || '')?.split(':')[0] || ''}:${String(_times[0]?.start_time || '')?.split(':')[1] || ''}`) : '',
                            end_time: _times[0] ? (`${String(_times[0]?.end_time || '')?.split(':')[0] || ''}:${String(_times[0]?.end_time || '')?.split(':')[1] || ''}`) : '',
                        })
                    });
                    return (<>
                        <div style={{ minWidth: '210px' }} className="d-flex flex-wrap gap-2">
                            {_times?.length ? <> {(_times || [])?.map((s: any, ind: number) => (
                                <div key={ind} className='d-flex w-100'>
                                    <span className="rounded-pill badge bg-success-subtle text-success fs-13">
                                        {s?.start_time}
                                    </span>
                                    {(String(item?.apptech?.type) === String(APP_TECH_TYPE.AUTOMATIC)) && <>
                                        <span className="text-success mx-1">~</span>
                                        <span className="rounded-pill badge bg-success-subtle text-success fs-13">
                                            {s?.end_time}
                                        </span>
                                        <span className="text-primary mx-1">~</span>
                                        <span className="rounded-pill badge bg-primary-subtle text-primary fs-13">
                                            <span className="fs-11">{t('__every')}</span> {s?.interval} <span className="fs-11">{t('__mins')}</span>
                                        </span>
                                    </>}
                                </div>
                            ))}</> : <>-</>}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Auto Publication'),
                accessor: "is_auto_publish",
                filterable: true,
                sortable: false,
                thWidth: 140,
                thClass: 'text-center align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '120px' }} className="text-center">
                            <span className={`rounded-pill badge bg-${item?.medias?.[0]?.is_auto_publish ? 'success' : 'danger'} fs-12`}>
                                {item?.medias?.[0]?.is_auto_publish ? 'On' : 'Off'}
                            </span>
                        </div>
                    </>)
                },
            },
            {
                Header: t('Use Content Paragraph'),
                accessor: "is_content_paragraph",
                filterable: true,
                sortable: false,
                thWidth: 140,
                thClass: 'text-center align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '120px' }} className="text-center">
                            <span className={`rounded-pill badge bg-${item?.is_content_paragraph ? 'success' : 'danger'} fs-12`}>
                                {item?.is_content_paragraph ? 'On' : 'Off'}
                            </span>
                        </div>
                    </>)
                },
            },
            {
                Header: t('Created At'),
                accessor: "created_at",
                filterable: true,
                sortable: true,
                thWidth: 130,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end pe-3" style={{ minWidth: '120px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            {
                Header: t('Updated at'),
                accessor: "updated_at",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'text-end align-middle',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end" style={{ minWidth: '100px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            {
                Header: t('Actions'),
                accessor: "__",
                thClass: 'align-middle text-center',
                thWidth: 150,
                sortable: false,
                Cell: (cell: any) => {
                    const item: any = cell?.row?.original;
                    return (
                        <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '130px' }}>
                            {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_GOLD_PRICE_UPDATE, userPermissions) && (
                                <TooltipCustom
                                    title={t('Generate Article')}
                                    id={`detail-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item" id={`detail-cp-${item?.id}`}>
                                        <Link className={`btn btn-sm btn-soft-primary edit-item-btn `} to="#"
                                            onClick={(e) => { e.preventDefault(); handleCreateNews(item) }}
                                        >
                                            {(idCampaignCreateNewsLoading === item?.id) ? <div style={{ transform: 'translateY(1px)' }}><Spinner size="sm" className="text-white" style={{ width: '12px', height: '12px' }}></Spinner></div> : <i className={`ri-restart-line align-bottom ${!!idCampaignCreateNewsLoading ? 'text-white' : ''}`}></i>}
                                        </Link>
                                    </li>
                                </TooltipCustom>
                            )}
                            {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_APP_TECH_UPDATE, userPermissions) && <TooltipCustom
                                title={t('Button Update Campaign')}
                                id={`update-us-${item?.id}`}
                            >
                                <li className=" list-inline-item me-0" id={`update-us-${item?.id}`}>
                                    <Link className="btn btn-sm btn-soft-primary edit-item-btn" to="#"
                                        onClick={(e) => { e.preventDefault(); handleSetCampaignDetail(item) }}
                                    >
                                        <i className="ri-pencil-fill align-bottom"></i>
                                    </Link>
                                </li>
                            </TooltipCustom>}
                            {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_APP_TECH_DELETE, userPermissions) && (
                                <TooltipCustom
                                    title={t('Button Delete Campaign')}
                                    id={`detail-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item" id={`detail-cp-${item?.id}`}>
                                        <Link className="btn btn-sm btn-soft-danger edit-item-btn" to="#"
                                            onClick={(e) => { e.preventDefault(); handleConfirmDelete(item) }}
                                        >
                                            <i className="ri-delete-bin-3-fill align-bottom"></i>
                                        </Link>
                                    </li>
                                </TooltipCustom>
                            )}
                        </ul>
                    );
                },
            },
        ],
        [i18n?.language, idLoading, idAutoPublishLoading, idCampaignCreateNewsLoading, JSON.stringify(query), JSON.stringify(userPermissions)]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return ({ ..._prev, ...sortBy });
        });
    }, []);

    const handleCallAllOption = async () => {
        try {
            const [res1, res2]: any = await Promise.all([allAppTech({}), getAllPartners({})]);
            const _list_app_tech = (res1?.data || [])?.map((ml: any, index: number) => ({ value: String(ml?.id), label: ml?.name, type: ml?.type }));
            const _list_partner = (res2?.data || [])?.map((ml: any, index: number) => ({ value: String(ml?.id), label: ml?.name, is_partner: ml?.is_partner, partner_codes: ml?.partner_codes, partner_reporters: ml?.partner_reporters }));
            setAppTechs((_prev: any) => _list_app_tech);
            setPartners((_prev: any) => _list_partner);

            if (query?.apptech_id) {
                const _val = (_list_app_tech)?.find((s: any) => String(s?.value) === String(query?.apptech_id));
                setAppSearch(_val);
            }

            if (query?.media_id) {
                const _val = (_list_partner)?.find((s: any) => String(s?.value) === String(query?.media_id));
                setMediaSearch(_val);
            }
        } catch (error: any) {
            return error;
        }
    };

    const handleChangePicker = (values: any[] = []) => {
        setDateSearch((_prev: any) => values);
    }

    useEffect(() => {
        handleCallAllOption();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <Row>
                {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_APP_TECH_LIST, userPermissions) && (
                    <Col lg={12}>
                        <div>
                            <CardHeader className="border-0">
                                <Row className="g-4 align-items-center">
                                    <div className="col-5">
                                        <div>
                                            <h5 className="card-title mb-0">
                                                <span>
                                                    <span className="me-2">{t('Total')}:</span>
                                                    {(isCampaignAppTechLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={campaignAppTechs?.pagination?.total || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-7 col-sm-7 text-end">
                                        {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_APP_TECH_CREATE, userPermissions) && (<div className="col-sm-auto">
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-success add-btn rounded-pill"
                                                    id="create-btn"
                                                    onClick={() => {
                                                        handleSetCampaignDetail({ time_request: + new Date() } as any)
                                                    }}
                                                >
                                                    <i className="ri-add-line align-bottom me-1"></i>
                                                    {t('Button Create Campaign')}
                                                </button>
                                            </div>
                                        </div>)}
                                    </div>
                                </Row>
                            </CardHeader>
                            <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                <Row className="g-4 align-items-center mt-0">

                                    <Col sm={6} md={6} lg={6} xl={3} xxl={3} className='mt-3 mt-xl-2'>
                                        <LabelWrapper label={t('App')} isShow={true}>
                                            <DropdownOption
                                                name="app"
                                                dataList={appTechs || []}
                                                placeholder={`${t("App")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={appSearch || null}
                                                onChangeSelect={(e: any) => setAppSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                            />
                                        </LabelWrapper>
                                    </Col>

                                    <Col sm={6} md={6} lg={6} xl={3} xxl={3} className='mt-3 mt-xl-2'>
                                        <LabelWrapper label={t('Media')} isShow={true}>
                                            <DropdownOption
                                                name="media"
                                                dataList={filterMediaOptions(partners || [])}
                                                placeholder={`${t("Media")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={mediaSearch || null}
                                                onChangeSelect={(e: any) => setMediaSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                            />
                                        </LabelWrapper>
                                    </Col>


                                    <Col sm={6} md={6} lg={6} xl={3} xxl={3} className='mt-3 mt-xl-2'>
                                        <LabelWrapper label={t('Status')} isShow={true}>
                                            <DropdownStatus
                                                name="status"
                                                dataList={STATUS_CAMPAIGN_OPTIONS_LANG || []}
                                                placeholder={`${t("Status")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={statusSearch || null}
                                                onChangeSelect={(e: any) => setStatusSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                                colors={COLORS_STATUS_CAMPAIGN}
                                            />
                                        </LabelWrapper>
                                    </Col>

                                    <Col sm={6} md={6} lg={6} xl={3} xxl={3} className="hstack gap-1 justify-content-center justify-content-sm-end justify-content-xl-start mt-3 mt-xl-2">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2 "
                                                onClick={searchData}
                                                disabled={isCampaignAppTechLoading}
                                            >
                                                <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                {t('Button Search')}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary fs-14"
                                                onClick={resetData}
                                            >
                                                <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                {t('Button Reset')}
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <CardBody className="pt-3">
                                <TableContainer
                                    className="custom-header-css"
                                    divClass="table-responsive table-card"
                                    tableClass="align-middle sticky-table-campaign-app-tech"
                                    theadClass="table-light"
                                    columns={columns}
                                    data={campaignAppTechs?.list?.length ? campaignAppTechs?.list : []}
                                    customPageSize={query.limit}
                                    customPageIndex={query.page - 1}
                                    totalRecords={campaignAppTechs?.pagination?.total}
                                    customPageCount={Math.ceil(Number(campaignAppTechs?.pagination?.total) / Number(campaignAppTechs?.pagination?.limit))}
                                    handleChangePage={handleChangePage}
                                    manualSorting={true}
                                    sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                                    handleChangeSorting={handleChangeSorting}
                                    isLoading={isCampaignAppTechLoading}
                                    isShowHeaderTableFixedTab={activeTab}
                                />
                            </CardBody>
                        </div>
                    </Col>
                )}
            </Row>

            <CampaignForm
                isOpen={!!campaignDetail}
                detail={campaignDetail}
                appTechs={appTechs}
                partners={partners}
                onClose={onCloseClick}
                triggerRefresh={triggerRefresh}
            />

            <ModalConfirm
                header={t('Button Delete Campaign')}
                isOpen={isOpenConfirm}
                isLoading={isConfirmLoading}
                onClose={onCloseConfirmClick}
                onConfirm={handleActionDelete}
            />

            <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={3000} limit={2} />
        </React.Fragment >
    );
};

export default CampaignList;